import React from 'react';
import LoadingCircle from "../pages/loadingCircles/LoadingCircle";

const Loader = () => {
   return  <div style={{position: 'fixed', zIndex: 9999, top: 0, left: 0, right: 0, bottom: 0, background: '#0a0a0ac7'}} >
    <div style={{display: "flex", flexDirection : "column", alignItems : "center", justifyContent : "center", height : "100vh"}}>
        <LoadingCircle />
    </div>
</div>
}

export default Loader;